import { render, staticRenderFns } from "./modalBase.vue?vue&type=template&id=40720fed&"
import script from "./modalBase.vue?vue&type=script&lang=js&"
export * from "./modalBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40720fed', component.options)
    } else {
      api.reload('40720fed', component.options)
    }
    module.hot.accept("./modalBase.vue?vue&type=template&id=40720fed&", function () {
      api.rerender('40720fed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/Common/Scripts/Components/modalBase.vue"
export default component.exports